module.exports = __webpack_public_path__ + "static/media/stretcher.e856b900.svg";